import { render, staticRenderFns } from "./hotGoods.vue?vue&type=template&id=22dc3282&scoped=true"
import script from "./hotGoods.vue?vue&type=script&lang=js"
export * from "./hotGoods.vue?vue&type=script&lang=js"
import style0 from "./hotGoods.vue?vue&type=style&index=0&id=22dc3282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc3282",
  null
  
)

export default component.exports